export default __webpack_public_path__ + "static/media/video-tv-0819.053994fc.m4v";